// components/StatusBadge.jsx
import React from 'react';

const STATUS_COLORS = {
  'Completed': '#28a745',
  'On Track': '#17a2b8',
  'Completed (Late)': '#10b981',
  'Ahead of Schedule': '#20c997',
  'At Risk': '#ffc107',
  'Behind Schedule': '#dc3545',
  'Not Started': '#6c757d',
};

const StatusBadge = ({ status }) => {
    const color = STATUS_COLORS[status] || '#6c757d';
    return (
        <div
            style={{
                display: 'inline-block',
                padding: '4px 12px',
                borderRadius: 12,
                backgroundColor: `${color}33`,
                color: color,
                fontWeight: 600,
                fontSize: 14,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
                border: `1.5px solid ${color}`,
                minWidth: 100,
                textAlign: 'center',
                userSelect: 'none', 
            }}
        >
            {status}
        </div>
    );
};

export default StatusBadge;